import { AuthService } from './../../../core/authentication/auth.service';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-employment-history-section',
  templateUrl: './employment-history-section.component.html',
  styleUrls: ['./employment-history-section.component.scss'],
  standalone: false
})
export class EmploymentHistorySectionComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);

  workerId: number;
  isLoggedUserProfile: boolean;

  constructor() { }

  ngOnInit(): void {
    this.route.parent.data.subscribe((data) => {
      this.workerId = data['workerProfile'].WorkerId;
      this.isLoggedUserProfile = data['workerProfile'].AuthServerUserId === this.authService.authServerUserId;
    });
  }
}
